import { type IconName } from '@aspendental/shared-components-web';

import { DigitalVisitReasonEnum } from '@src/lib/__generated/api';

export interface ReasonForVisit {
	value: DigitalVisitReasonEnum;
	icon: IconName;
	label: string;
	filterBy?: string;
}

export const REASONS_FOR_VISIT: ReasonForVisit[] = [
	{
		value: DigitalVisitReasonEnum.Emergency,
		icon: 'Emergency',
		label: 'Emergency',
		filterBy: 'EMERGENCY',
	},
	{
		value: DigitalVisitReasonEnum.BrokenToothToothPain,
		icon: 'BrokenTooth',
		label: 'Broken Tooth/Tooth Pain',
		filterBy: 'BROKEN_TOOTH_TOOTH_PAIN',
	},
	{
		value: DigitalVisitReasonEnum.Implants,
		icon: 'Implant',
		label: 'Dental Implants',
		filterBy: 'IMPLANTS',
	},
	{
		value: DigitalVisitReasonEnum.Dentures,
		icon: 'Dentures',
		label: 'Dentures',
		filterBy: 'DENTURES',
	},
	{
		value: DigitalVisitReasonEnum.ClearAligners,
		icon: 'Invisalign',
		label: 'Motto™ Clear Aligners',
		filterBy: 'CLEAR_ALIGNERS',
	},
	{
		value: DigitalVisitReasonEnum.Other,
		icon: 'CheckUp',
		label: 'Other/Check Up',
		filterBy: 'OTHER',
	},
];

export const REASONS_FOR_VISIT_ES: ReasonForVisit[] = [
	{
		value: DigitalVisitReasonEnum.Emergency,
		icon: 'Emergency',
		label: 'Emergencia',
		filterBy: 'EMERGENCY',
	},
	{
		value: DigitalVisitReasonEnum.BrokenToothToothPain,
		icon: 'BrokenTooth',
		label: 'Diente roto/dolor de muelas',
		filterBy: 'BROKEN_TOOTH_TOOTH_PAIN',
	},
	{
		value: DigitalVisitReasonEnum.Implants,
		icon: 'Implant',
		label: 'Implantes dentales',
		filterBy: 'IMPLANTS',
	},
	{
		value: DigitalVisitReasonEnum.Dentures,
		icon: 'Dentures',
		label: 'Dentaduras postizas',
		filterBy: 'DENTURES',
	},
	{
		value: DigitalVisitReasonEnum.ClearAligners,
		icon: 'Invisalign',
		label: 'Alineadores transparentes Motto™',
		filterBy: 'CLEAR_ALIGNERS',
	},
	{
		value: DigitalVisitReasonEnum.Other,
		icon: 'CheckUp',
		label: 'Otro/Chequeo',
		filterBy: 'OTHER',
	},
];

const reasonMap = (array: ReasonForVisit[]) =>
	array.reduce((obj, item, index) => {
		obj[item.value] = ++index;
		return obj;
	}, {});

export const REASON_FOR_VISIT_ID = reasonMap(REASONS_FOR_VISIT);
export const REASON_FOR_VISIT_ID_ES = reasonMap(REASONS_FOR_VISIT_ES);
